import { getEnv } from '@/shared/utils/get-env.ts';

/**
 * Central configuration for PostHog (posthog-js) analytics + session replay.
 * The UI is web content in a WebView, so replay runs via rrweb on all platforms.
 */
export const sessionReplayConfig = {
  /** PostHog project API key. Read lazily so tests never require it at import time. */
  apiKey: (): string => getEnv('VITE_POSTHOG_KEY'),

  /** US cloud ingestion host. Must match the project's region. */
  host: 'https://us.i.posthog.com',

  /** Autocapture clicks/taps and interactions (enables heatmaps / clickmaps). */
  autocapture: true,

  /** Detect rage clicks. */
  rageclick: true,

  /** Mask all input fields in replays. Images/video stay visible by default. */
  maskAllInputs: true,

  sampleRate: 1,

  /** REQUIRED for WebView/video content to appear in replays. */
  screenshotMode: true,

  /**
   * Route names on which recording is paused. Extend as Legal/BA identify more
   * sensitive screens.
   */
  sensitiveRouteNames: ['Login', 'Register', 'PrivacyPolicy', 'PublicPrivacyPolicy'],
} as const;
